import React from "react"

import BackgroundImage from "../../../../common/BackgroundImage"
import SideCheckBox from "../../../../common/SideCheckBox"

const CommunityMemberAddListItem = ({
    id,
    full_name,
    photo_url,
    primary_position,
    primary_organisation,
    addMember,
    isAdded
}) => (
    <div
        className="list-group-item"
        onClick={addMember({
            id,
            full_name,
            photo_url,
            primary_position,
            primary_organisation,
            isAdded
        })}
    >
        <BackgroundImage
            classList={["list-group-item-thumb", "people-circle"]}
            imageUrl={photo_url}
        />
        <div className="list-group-item-content">
            <div className="item-to-right">
                <h4 className="text-shorten-single-line">
                    {full_name}&nbsp;
                    <span className="small">{primary_position}</span>
                </h4>
                <p>{primary_organisation}</p>
            </div>
            <SideCheckBox isAdded={isAdded} />
        </div>
    </div>
)

export default CommunityMemberAddListItem
